module.exports = __webpack_public_path__ + "img/project_11.d7f468d4.jpg";